import styled from 'styled-components';
import iconWaves from '../../../../assets/icons/shape_waves.svg';
import BaseLogo from '../../Logo';

export const SectionSteps = styled.section`
  display: flex;
  flex-grow: 1;
  width: 40%;
  background-image: url(${iconWaves});
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: white;
  height: 100%;
  box-shadow: 0px 3px 16px rgba(130, 130, 130, 0.3);
`;

export const StepsContainer = styled.div`
  width: 290px;
  height: 290px;
  margin: 80px auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Logo = styled(BaseLogo)`
  width: 136px;
  height: 39px;
`;
